import React from 'react'
import { Router } from 'react-router-dom'
import './App.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createBrowserHistory } from 'history'
import { useAuth0 } from './utils/auth'
import { Toast } from './components'
import AppLoading from './components/AppLoading'
import { FullScreenImage } from './components/FullScreenImage'
import { useKeyboardShortcuts } from './useKeyboardShortcuts'
import './utils/FormSaveStore/UnloadScript'
import { GlobalSearchPage, useGlobalSearchPageStore } from './views/GlobalSearch/GlobalSearchPage'
import { LiveViewFullscreenModal } from './views/LiveView/LiveViewFullscreenModal'
import { LoginContainer } from './views/Login'

// Switch to Websocket middleware concept:
// https://gist.github.com/cowlicks/71e766164647f224bf15f086ea34fa52

export const browserHistory = createBrowserHistory()

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            staleTime: 5000
        }
    }
})

const App: React.FC = () => {
    /**
     * Stateful Functional component containing all components for the webpage
     *
     * @returns a React Functional Component
     */
    const path = window.location.hash.slice(1)

    if (path) {
        window.location.hash = ''
        browserHistory.replace(path)
    }
    const { loading, error } = useAuth0()
    const setIsOpen = useGlobalSearchPageStore((state) => state.setIsOpen)
    useKeyboardShortcuts([
        {
            key: 'k',
            ctrlKey: true,
            callback: () => {
                setIsOpen(true)
            }
        },
        {
            key: 'k',
            metaKey: true,
            callback: () => {
                setIsOpen(true)
            }
        }
    ])

    if (loading) {
        return <AppLoading />
    } else if (error) {
        return <div>Error</div>
    }

    return (
        <>
            <LiveViewFullscreenModal />
            <Toast />
            <FullScreenImage />
            <QueryClientProvider client={queryClient}>
                {/* <div className="App"> */}
                <Router history={browserHistory}>
                    <GlobalSearchPage />
                    <LoginContainer />
                </Router>
                {/* </div> */}
            </QueryClientProvider>
        </>
    )
}

export default App
